var map = {
	"./de/cv-bg.png": "DEi+",
	"./en/cv-bg.png": "/URo",
	"./es/cv-bg.png": "7Ow2",
	"./fr/cv-bg.png": "cN/8",
	"./ja/cv-bg.png": "kjTl",
	"./ko/cv-bg.png": "muhH",
	"./pt/cv-bg.png": "D/3f",
	"./ru/cv-bg.png": "2Hyu",
	"./tc/cv-bg.png": "7aHM",
	"./th/cv-bg.png": "Nk09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Iorm";